module.exports = __webpack_public_path__ + "static/media/hero-interior-kitchen.00f89774.jpg";